var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "repeat-option-warning" }, [
    _c("div", { staticClass: "repeat-option-warning__icon icon icon-info" }),
    _vm._v(" "),
    _c("strong", { staticClass: "repeat-option-warning__info" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(
            _vm.$t(
              "calendar",
              "This event is the recurrence-exception of a recurrence-set. You can not add a recurrence-rule to it."
            )
          ) +
          "\n\t"
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }